import { render, staticRenderFns } from "./RegimeEstadual.vue?vue&type=template&id=450500e6&scoped=true"
import script from "./RegimeEstadual.vue?vue&type=script&lang=js"
export * from "./RegimeEstadual.vue?vue&type=script&lang=js"
import style0 from "./RegimeEstadual.vue?vue&type=style&index=0&id=450500e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450500e6",
  null
  
)

export default component.exports